import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

// Previzualizarea paginilor, cu aceeași randare ca în magazin (Markdown fără HTML brut).
export default function Markdown({ children }: { children: string }) {
  return (
    <div className="prose-page">
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={{ a: ({ href, children }) => <a href={href} target="_blank" rel="noopener">{children}</a> }}>
        {children}
      </ReactMarkdown>
    </div>
  );
}

// fill înlocuiește {{cheie}} cu valorile din datele firmei, exact ca API-ul magazinului.
export function fill(body: string, vals: Record<string, string>) {
  return body.replace(/\{\{\s*([a-z_]+)\s*\}\}/g, (m, k: string) => vals[k] ?? m);
}
